import { gql } from '@apollo/client';

export const ImageFragment = gql`
  fragment ImageFragment on UploadFileEntity {
    attributes {
      url
      alternativeText
      mime
    }
  }
`;
